<div class="profile-container">
  <!-- Back Button & Header -->
  <div class="profile-actions-header">
    @if (showBackButton) {
      <button class="back-btn" (click)="goBack()" type="button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="back-icon"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        {{ backButtonText }}
      </button>
    }
    <div class="page-title">Profile Details</div>
  </div>

  @if (isLoading) {
    <div class="loading-state">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        class="spin-icon"
      >
        <path
          d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
        />
      </svg>
      <span>Loading user profile...</span>
    </div>
  }

  @if (!isLoading && !isNotFound && userProfileDetails) {
    <div class="profile-card">
      <div class="profile-header">
        <div class="profile-left">
          <div class="profile-avatar">
            @if (userProfileDetails.profile_image_path !== null) {
              <img
                [src]="getImageUrl(userProfileDetails.profile_image_path)"
                alt="Profile"
                class="profile-img"
              />
            } @else {
              <div class="avatar-initials">
                {{
                  (
                    userProfileDetails.first_name ||
                    userProfileDetails.last_name ||
                    "-"
                  )
                    .charAt(0)
                    .toUpperCase()
                }}
              </div>
            }
          </div>

          <div class="profile-info">
            <h1 class="user-fullname">
              {{
                userProfileDetails.first_name && userProfileDetails.last_name
                  ? userProfileDetails.first_name +
                    " " +
                    userProfileDetails.last_name
                  : userProfileDetails.first_name ||
                    userProfileDetails.last_name ||
                    "-"
              }}
            </h1>
            <p class="user-email-subtitle">
              {{ userProfileDetails.email || "-" }}
            </p>
          </div>
        </div>
      </div>

      <div class="details-grid">
        <div class="detail-item">
          <div class="detail-label">First Name</div>
          <div class="detail-value">
            {{ userProfileDetails.first_name || "-" }}
          </div>
        </div>

        <div class="detail-item">
          <div class="detail-label">Last Name</div>
          <div class="detail-value">
            {{ userProfileDetails.last_name || "-" }}
          </div>
        </div>

        <div class="detail-item">
          <div class="detail-label">Email</div>
          <div class="detail-value">
            {{ userProfileDetails.email || "-" }}
          </div>
        </div>

        @if (userProfileDetails.connection_display_name) {
          <div class="detail-item">
            <div class="detail-label">Organization</div>
            <div class="detail-value">
              {{ userProfileDetails.connection_display_name }}
            </div>
          </div>
        }

        @if (userProfileDetails.date_joined) {
          <div class="detail-item">
            <div class="detail-label">Member Since</div>
            <div class="detail-value">
              {{ userProfileDetails.date_joined | date: "mediumDate" }}
            </div>
          </div>
        }

        @if (userProfileDetails.last_login) {
          <div class="detail-item">
            <div class="detail-label">Last Login</div>
            <div class="detail-value">
              {{ userProfileDetails.last_login | date: "medium" }}
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (isNotFound && !isLoading) {
    <div class="empty-state">
      <div class="empty-title">User Not Found</div>
      <div class="empty-description">
        The requested user profile does not exist.
      </div>
    </div>
  }
</div>
